// extracted by mini-css-extract-plugin
export default {"container":"MensajeEvaluacion_container__LUle1","titulo":"MensajeEvaluacion_titulo__bnXEp","icon":"MensajeEvaluacion_icon__4bztO","texto":"MensajeEvaluacion_texto__NRjBY"};